export interface SequenceStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

export interface FilenameResult {
  filename: string;
  warning?: string;
}

function localDateKey(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}

export function dateLabel(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${month}-${day}-${date.getFullYear()}`;
}

export function makeOutputFilename(date = new Date(), storage?: SequenceStorage): FilenameResult {
  const dateKey = localDateKey(date);
  const base = `orders ${dateLabel(date)}`;
  if (!storage) {
    return {
      filename: `${base}.pdf`,
      warning: 'Offline filename numbering is unavailable in this browser; the download may reuse an existing filename.',
    };
  }

  const key = `daraz-pdf-automator:sequence:${dateKey}`;
  try {
    const prior = Number.parseInt(storage.getItem(key) ?? '0', 10);
    const sequence = Number.isFinite(prior) && prior >= 0 ? prior + 1 : 1;
    storage.setItem(key, String(sequence));
    return { filename: `${base}${sequence === 1 ? '' : ` ${sequence}`}.pdf` };
  } catch {
    return {
      filename: `${base}.pdf`,
      warning: 'Offline filename numbering is unavailable in this browser; the download may reuse an existing filename.',
    };
  }
}
